import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import TagManager from 'react-gtm-module';
import { BrowserCacheLocation } from '@azure/msal-browser';

import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import Head from './components/Head';
import { getDomain } from './utils/functions';

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID ?? '';
const knownAuthorities = [process.env.REACT_APP_MSAL_KNOWN_AUTHORITY ?? ''];
const authority = process.env.REACT_APP_MSAL_AUTHORITY ?? '';
const msalConfig = {
  auth: {
    clientId,
    scopes: ['openid'],
    // According to the documentation, the login redirect page
    // should be a nonexistent blank page.
    redirectUri: '/login',
    authority,
    knownAuthorities,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};
const publicClientApplication = new PublicClientApplication(msalConfig);

const domain = getDomain();
const gtmId: { [key: string]: string } = {};
gtmId['ruka'] = process.env.REACT_APP_GTM_ID_RUKA ?? '';
gtmId['pyha'] = process.env.REACT_APP_GTM_ID_PYHA ?? '';

const tagManagerArgs = {
  gtmId: gtmId[domain],
};
TagManager.initialize(tagManagerArgs);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <Head />
      <MsalProvider instance={publicClientApplication}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
